var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgConversationStatus = function SvgConversationStatus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-monochrome-white)",
    d: "M29.75 33.26s-.08-.01-.12.02l.06-.06s.04.03.06.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-monochrome-white)",
    d: "M47.81 28.17c-.37-2.59-1.46-5.08-3-7.18-1.89-2.58-4.52-4.51-7.68-5.18-4.98-.71-10.27 0-14.41 3.04-3.54 2.59-5.94 6.56-6.53 10.91-.54 4.03.38 8.68 3.21 11.74 3.24 3.49 8.64 4.36 13.18 3.83 1.4-.17 2.78-.5 4.11-.99.64-.23 1.26-.51 1.87-.83.26-.14 1.48-1.13 1.73-1.07.18.05.78 1.52.9 1.79.45 1.07.83 2.21 1.03 3.36.04.24.24 1.06.66.8.38-.23.6-.84.79-1.22.42-.88.78-1.79 1.11-2.71.99-2.68 1.81-5.43 2.4-8.23.55-2.61 1.02-5.4.63-8.06Zm-9.36-1.02c-2.17 2.98-4.34 5.95-6.51 8.93-.28.37-.55.75-.82 1.12-.24.33-.49.73-.86.93-.78.4-1.52-.46-1.99-.97-.45-.49-.87-1.01-1.29-1.52-.21-.26-.42-.52-.65-.77l-.3-.33c-.02-.02-.07-.08-.11-.12l-.05-.05c-.78-.75-.88-1.97-.79-3.01.03-.46.17-1.12.47-1.5.15-.21.56-.53.84-.28.96.87 1.73 1.91 2.57 2.89.18.21.37.41.56.6l.02.03s.01.01.02.01c.02.02.05.04.07.06s.04.04.06.05c.26-.26.48-.67.69-.96.25-.34.5-.68.75-1.03 2.03-2.79 4.07-5.58 6.11-8.37.68-.93 1.32.23 1.52.86.33 1.01.34 2.54-.31 3.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.75 33.26s-.08-.01-.12.02l.06-.06s.04.03.06.04Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgConversationStatus);
export default ForwardRef;